import {
  useRecordContext,
  RecordContextProvider,
  NumberField,
  TabbedShowLayout,
  useTranslate,
  TextField,
} from "react-admin";
import Box from "@mui/material/Box";
import React from "react";

const InventoryWriteOffExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();
  return (
    <TabbedShowLayout
      syncWithLocation={false}
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
        "& .RaTabbedShowLayout-content": {
          p: 0,
        },
        "& .RaLabeled-label": {
          display: "none",
        },
      }}
    >
      <TabbedShowLayout.Tab label={t("mine.label.product")}>
        <Box
          component="table"
          sx={{
            width: "100%",
            // bgcolor: "rgba(0,0,0,.04)",
            // fontSize: "smaller",
            borderCollapse: "collapse",
            "& th, td": {
              padding: "6px 8px",
              border: "1px solid #dddddd",
            },
          }}
        >
          <thead>
            <tr>
              <th>{t("mine.label.product_code")}</th>
              <th>{t("mine.label.product_name")}</th>
              <th style={{ textAlign: "center" }}>
                {t("mine.label.warehouse")}
              </th>
              <th style={{ textAlign: "right" }}>{t("mine.label.quantity")}</th>
            </tr>
          </thead>
          <tbody>
            {record.mutation_inventory_write_off_items.map((item, idx) => {
              return (
                <tr key={item.id}>
                  <td>{item.product.code}</td>
                  <td>{item.product.name}</td>
                  <td style={{ textAlign: "center" }}>
                    <RecordContextProvider value={item}>
                      <TextField
                        source="warehouse.name"
                        sx={{
                          fontSize: "inherit",
                        }}
                      />
                    </RecordContextProvider>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    <RecordContextProvider value={item}>
                      <NumberField
                        source="quantity"
                        sx={{
                          fontSize: "inherit",
                        }}
                      />
                    </RecordContextProvider>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Box>
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  );
};

export default InventoryWriteOffExpandList;
